export default __webpack_public_path__ + "78120e060f775cf52d48aaccbc69a0b4.png";